import Wpp from 'components/wpp/Wpp'
import About from '../components/about/About'
import Card from '../components/card/Card'
import { Maragogi } from '../components/home/Maragogi'
import Parallax from '../components/parallax/parallax'
import Swiper from '../components/slider/Swiper'
import type { Route } from './+types'

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Maragogi ao Mar" },
    { name: "description", content: "Piscinas Naturais, Passeio de Buggy e Jet Ski em Maragogi" },
  ];
}

export default function index() {
  return (
    <>
      <Swiper />
      <Maragogi />
      <div className="flex flex-wrap justify-center my-10">
        <Card title="Passeio de lancha para as Piscinas Naturais de Maragogi" image="/cards/01.jpeg" href="/piscinas-naturais" /> 
        <Card title="Tire lindas fotos subaquáticas nas Piscinas Naturais" image="/home/09.jpg" href="/fotos-subaquaticas" />
        <Card title="Visite a Croa da Bruna, um paraíso no meio do Mar" image="/cards/03.jpeg" href="/croa-da-bruna" />
      </div>
      <Parallax />
      <About></About>
      <Wpp></Wpp>
    </>
  )
}
